export default "__VITE_ASSET__BO2GT$1o__"